import { useState, useEffect } from 'react';
import styled from 'styled-components';

interface GenreModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (selectedGenre: string) => void;
  genres: Array<{
    genre: string;
    selected: boolean;
  }>;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 420px;
  background: white;
  border-radius: 12px;
  padding: 16px 20px 24px;
  text-align: center;
  z-index: 1000;
`;

const ModalTitle = styled.h3`
  display: flex;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: #333333;
`;

const ModalDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: black;
  margin-bottom: 24px;
  line-height: 1.5;
  display: flex;
  text-align: left;
`;

const GenreList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
`;

const GenreButton = styled.button<{ isSelected?: boolean }>`
  width: 100%;
  height: 45px;
  border-radius: 8px;
  border: none;
  background: ${props => props.isSelected ? '#2282E9' : '#EBF5FF'};
  color: ${props => props.isSelected ? 'white' : '#2282E9'};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.isSelected ? '#2282E9' : '#2282E9'};
    color: white;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 12px;
  margin-top: 60px;
`;

const CancelButton = styled.button`
  flex: 1;
  height: 45px;
  border-radius: 100px;
  border: 1px solid #E3E3E3;
  background: #C0C0C0;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

const ConfirmButton = styled.button`
  flex: 1;
  height: 45px;
  border-radius: 100px;
  border: none;
  background: #2282E9;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

const HorizontalDivider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0px 0 30px 0;
`;

const getGenreDisplayName = (genre: string) => {
  console.log(`genre: ${genre}`);
  switch (genre) {
    case 'RPG_GAME':
      return 'RPG';
    case 'ACTION_SHOOTER_GAME':
      return '액션 및 슈팅';
    case 'STRATEGY_GAME':
      return '전략 및 전술';
    case 'SIMULATION_TYCOON_GAME':
      return '시뮬레이션 및 경영';
    case 'CASUAL':
      return '캐주얼';
    default:
      return 'test';
  }
};

export default function GenreModal({ isOpen, onClose, onConfirm, genres: initialGenres }: GenreModalProps) {

  const initialSelectedGenre = initialGenres.find(g => g.selected)?.genre || null;
  
  const [selectedGenre, setSelectedGenre] = useState<string | null>(initialSelectedGenre);
  const [displayGenres, setDisplayGenres] = useState<Array<{ genre: string; selected: boolean }>>(initialGenres);
  // useEffect를 사용하여 initialGenres가 변경될 때마다 selectedGenre 업데이트
  useEffect(() => {
    const newSelectedGenre = initialGenres.find(g => g.selected)?.genre || null;
    setSelectedGenre(newSelectedGenre);
    setDisplayGenres(initialGenres);
  }, [initialGenres]);
  
  // const displayGenres = initialGenres;
  
  if (!isOpen) return null;

  const handleGenreClick = (genre: string) => {
    setSelectedGenre(genre);
  };

  const handleConfirm = () => {
    if (selectedGenre) {
      onConfirm(selectedGenre);
      onClose();
    }
  };

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <Modal>
        <ModalTitle>장르별 질문</ModalTitle>
        <HorizontalDivider />
        <ModalDescription>
          2단계 프로젝트 정보에서 작성해주신<br />
          게임의 장르 중 1가지를 선택해 질문지를 완성하세요!
        </ModalDescription>
        <GenreList>
          {displayGenres.map((genre) => (
            <GenreButton
              key={genre.genre}
              isSelected={selectedGenre === genre.genre}
              onClick={() => handleGenreClick(genre.genre)}
            >
              {getGenreDisplayName(genre.genre)}
            </GenreButton>
          ))}
        </GenreList>
        <ButtonContainer>
          <CancelButton onClick={onClose}>뒤로 가기</CancelButton>
          <ConfirmButton
            onClick={handleConfirm}
            disabled={!selectedGenre}
            style={{
              opacity: selectedGenre ? 1 : 0.5,
              cursor: selectedGenre ? 'pointer' : 'not-allowed'
            }}
          >
            선택 완료
          </ConfirmButton>
        </ButtonContainer>
      </Modal>
    </>
  );
} 